import { UserMetadata } from "@safetyculture/s12-apis-connect-web/s12/featureflags/v1/featureflag_pb";
import {
  EvalAllFlagsRequest,
  EvalAllFlagsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/featureflags/v1/featureflags_pb";
import {
  AddFeatureFlagSegmentMembersRequest,
  AddFeatureFlagSegmentMembersResponse,
  ListFeatureFlagSegmentsRequest,
  ListFeatureFlagSegmentsResponse,
  RemoveFeatureFlagSegmentMembersRequest,
  RemoveFeatureFlagSegmentMembersResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/feature_flag_pb";
import { SCEmployee } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/workflows_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

type ListFeatureFlagsSegmentsParams = {
  organisationIds?: string[];
};

export const listFeatureFlagSegments = async (
  { organisationIds }: ListFeatureFlagsSegmentsParams,
  headers: Record<RequestMetadata, string>
): Promise<ListFeatureFlagSegmentsResponse> => {
  const req = new ListFeatureFlagSegmentsRequest();

  if (organisationIds && organisationIds.length > 0) {
    req.organisationIds = organisationIds;
  }

  return supportServiceConnectClient.listFeatureFlagSegments(req, { headers });
};

type AddFeatureFlagSegmentMembersParams = {
  segmentKey: string;
  organisationIds: string[];
  employeeEmail: string;
  employeeName: string;
};

export const addFeatureFlagSegmentMembers = async (
  {
    segmentKey,
    organisationIds,
    employeeEmail,
    employeeName,
  }: AddFeatureFlagSegmentMembersParams,
  headers: Record<RequestMetadata, string>
): Promise<AddFeatureFlagSegmentMembersResponse> => {
  const req = new AddFeatureFlagSegmentMembersRequest({
    segmentKey,
    organisationIds,
  });

  const scEmployee = new SCEmployee({
    email: employeeEmail,
    name: employeeName,
  });
  req.scEmployee = scEmployee;

  return supportServiceConnectClient.addFeatureFlagSegmentMembers(req, {
    headers,
  });
};

type RemoveFeatureFlagSegmentMembersParams = {
  segmentKey: string;
  organisationIds: string[];
  employeeEmail: string;
  employeeName: string;
};

export const removeFeatureFlagSegmentMembers = async (
  {
    segmentKey,
    organisationIds,
    employeeEmail,
    employeeName,
  }: RemoveFeatureFlagSegmentMembersParams,
  headers: Record<RequestMetadata, string>
): Promise<RemoveFeatureFlagSegmentMembersResponse> => {
  const req = new RemoveFeatureFlagSegmentMembersRequest({
    segmentKey,
    organisationIds,
  });

  const scEmployee = new SCEmployee({
    email: employeeEmail,
    name: employeeName,
  });
  req.scEmployee = scEmployee;

  return supportServiceConnectClient.removeFeatureFlagSegmentMembers(req, {
    headers,
  });
};

export type FeatureFlags = Record<string, string | number | boolean>;

type EvalAllFlagsParams = {
  userId?: string;
  organizationId?: string;
  ignoreResolutionErrors?: boolean;
  isAnonymous?: boolean;
};

export const evalAllFlags = async (
  {
    userId,
    organizationId,
    ignoreResolutionErrors = false,
    isAnonymous = false,
  }: EvalAllFlagsParams,
  headers: Record<RequestMetadata, string>
): Promise<EvalAllFlagsResponse> => {
  const userMD = new UserMetadata({
    ignoreResolutionErrors,
    isAnonymous,
  });

  if (userId) {
    userMD.evaluateFor = { case: "userId", value: userId };
  }
  if (organizationId) {
    userMD.evaluateFor = { case: "orgId", value: organizationId };
  }

  const req = new EvalAllFlagsRequest({ user: userMD });

  return supportServiceConnectClient.evalAllFlags(req, {
    headers,
  });
};
